/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import logo from "/anchorsBetaLogo.png";
import { useAuth } from "../../Providers/Auth";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import { useGeneralSettings } from "../../Providers/General";
import { PiCoins } from "react-icons/pi";
import { BiSync } from "react-icons/bi";
import { Button } from "../../shadcnComponents/ui/button";
import { Eye, SquareArrowUpRight, Wallet, Wrench } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../shadcnComponents/ui/popover";
import { TbDeviceAnalytics } from "react-icons/tb";
import { IoFlashOutline } from "react-icons/io5";
import { MdAutoGraph, MdAutoStories, MdLoyalty } from "react-icons/md";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../shadcnComponents/ui/accordion";
import { IoMdOpen } from "react-icons/io";
import { cn } from "@/lib/utils";

// ----- branding logos -----
// import lightAnchorsLogo from "/anchors.svg";
import darkCollabLogo from "/collabLogo.png";
import lightCollabLogo from "/collabWhiteLogo.svg";

export const GlobalBranding = {
  name: "anchors",
  logo: {
    light: lightCollabLogo,
    dark: darkCollabLogo,
  },
};

interface NavbarProps {
  profile: string;
  chips?: number;
  topCreatorChips?: number;
}

// main page navbar ----------------
const Navbar = ({
  bg = "white",
  hideUserName,
  hideName = false,
}: {
  bg: string;
  hideUserName?: boolean;
  hideName?: boolean;
}) => {
  const navigate = useNavigate();

  const authState = useAuth();

  return (
    <div
      className={cn(
        `w-full box-border px-[4%] md:px-[10%] py-3 flex items-center justify-between top-0 left-0`,
        bg
      )}
    >
      <img
        src={
          bg === "white"
            ? logo
            : // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/anchors_Christmas.svg"
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/DiwaliLogoBlack.png"
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Collab+White+Logo.svg"
              "https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png"
        }
        alt=""
        className="w-20 md:w-32 cursor-pointer"
        onClick={() => {
          navigate("/");
        }}
      />

      {!hideUserName && authState?.loggedUser && (
        <section className="flex items-center gap-3 ">
          {!hideName && (
            <span className="font-public text-sm md:text-xl font-medium text-[#FFF]">
              {authState?.loggedUser?.name}
            </span>
          )}
          <img
            src={
              authState?.loggedUser?.profile ||
              "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/creatorProfileIcon2.png"
            }
            alt=""
            className="rounded-full md:w-10 md:h-10 w-6 h-6"
          />
        </section>
      )}
    </div>
  );
};

// user pages navbar -----------
export const Navbar2: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      className={`w-full box-border px-[9%] py-3 flex items-center justify-between bg-white
      }`}
    >
      <img
        src={logo}
        onClick={() => {
          mixpanel.track("Clicked on Collab Logo");
          navigate("/");
        }}
        alt=""
        className="w-20 md:w-32 cursor-pointer"
      />
    </div>
  );
};

// dashboard navbar
export const Navbar3: React.FC<NavbarProps> = ({
  profile,
  chips,
  topCreatorChips,
}) => {
  const generalState = useGeneralSettings();
  const navigate = useNavigate();
  const [openChipsInfo, setOpenChipsInfo] = useState(false);
  const [MostChipsInfo, OpenMostChipsInfo] = useState(false);
  const authState = useAuth();

  return (
    <>
      {openChipsInfo && (
        <div className="w-screen h-screen fixed top-0 left-0 z-40 flex items-center justify-center bg-[#12121280]">
          <div className="flex flex-col p-5 gap-5 items-center justify-center text-center w-[400px] bg-[#F5F5F5] rounded-lg font-inter text-[#757575] text-[16px]">
            {/* <h1 className="text-xl font-bold text-[#424242]">What is Chips</h1> */}

            <p>
              <b>Chips are your currency to attract brands</b>
            </p>
            <p className="w-[full] flex gap-1 flex-col text-start justify-start">
              <p>Aim for 300+ chips for maximum visibility.</p>
              <b>To earn chips:</b>
              <ul style={{ marginLeft: "20px", listStyle: "disc" }}>
                <li>
                  <b>Complete your profile:</b> Accuracy matters! Every detail
                  unlocks more chips. <br />
                </li>
                <li>
                  <b>Share the love:</b> Invite friends & score 20 chips each!
                </li>
              </ul>
            </p>
            <p>
              Top 5 Chip earners get "Featured" for brands to see, so aim high!
            </p>

            <button
              className="px-5 py-3 rounded bg-[#FF5C5C] text-sm text-[#FAFAFA]"
              onClick={() => {
                mixpanel.track("Got it clicked on Your Chips Collected Info");
                setOpenChipsInfo(false);
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}

      {MostChipsInfo && (
        <div className="w-screen h-screen fixed top-0 left-0 z-40 flex items-center justify-center bg-[#12121280]">
          <div className="flex flex-col p-5 gap-5 items-center justify-center text-center w-[400px] bg-[#F5F5F5] rounded-lg font-inter text-[#757575] text-[16px]">
            {/* <h1 className="text-xl font-bold text-[#424242]">What is Chips</h1> */}

            <p>
              <b>Chips are your currency to attract brands</b>
            </p>
            <p className="text-left">
              This is the highest chips collected yet by your fellow creators.{" "}
              <br />
              Can you beat it?
            </p>
            <p className="w-full flex gap-1 flex-col text-start justify-start">
              <b>Collect more chips:</b>
              <ul style={{ listStyle: "disc", marginLeft: "20px" }}>
                <li>
                  <div>
                    Build your profile ( <i> accuracy matters! </i>)
                  </div>
                </li>
                <li>
                  <div>
                    Refer friends (<i> both earn 20 chips! </i>)
                  </div>
                </li>
              </ul>
            </p>
            <p>
              Top 5 Chip earners get "Featured" for brands to see, so aim high!
            </p>

            <button
              className="px-5 py-3 rounded bg-[#FF5C5C] text-sm text-[#FAFAFA]"
              onClick={() => {
                mixpanel.track("Got it clicked on Most Chips Collected Info");
                OpenMostChipsInfo(false);
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}

      <div className="w-full box-border px-5 py-3 flex items-center flex-row-reverse gap-4 md:gap-8 bg-[#171717] border-b-[1px] border-[#262626] relative">
        <Popover>
          <PopoverTrigger>
            <img
              src={
                profile ||
                "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/creatorProfileIcon2.png"
              }
              alt=""
              className="rounded-full w-10 h-10"
            />
          </PopoverTrigger>
          <PopoverContent className="bg-[#212121] border-none text-white mr-4 md:mt-1">
            <div
              className="space-y-4 overflow-y-scroll max-h-[70vh]"
              style={{ scrollbarWidth: "none" }}
            >
              {/* profile section --------- */}
              <section className="flex flex-col items-center">
                <div
                  className="flex flex-col items-center cursor-pointer"
                  onClick={() => {
                    if (
                      authState?.loggedUser?.activePlan &&
                      authState?.loggedUser?.slug
                    ) {
                      navigator.clipboard.writeText(
                        `${window.location.origin}/${authState?.loggedUser?.slug}`
                      );
                      window.open(
                        `${window.location.origin}/${authState?.loggedUser?.slug}`,
                        "_blank"
                      );
                    }
                  }}
                >
                  <img
                    src={
                      profile ||
                      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/creatorProfileIcon2.png"
                    }
                    alt=""
                    className="rounded-full w-10 h-10"
                  />
                  <p className="">{authState?.loggedUser?.name}</p>
                  <p className="text-[10px] text-[#A6A6A6]">
                    {authState?.loggedUser?.email}
                  </p>
                </div>
                <div className="h-2" />

                {/* chips collected details --------- */}
                <section className="space-y-2">
                  <span
                    className="bg-[#381c1c] py-2 px-3 border-none rounded-lg text-[#FFFFFF] flex items-center gap-2 cursor-pointer text-xs"
                    onClick={() => {
                      setOpenChipsInfo(true);
                      mixpanel.track("Clicked the chips on Navbar in Collab");
                    }}
                  >
                    <PiCoins size={16} color="#FFD700" /> Your Chips Collected -{" "}
                    {generalState.SidebarChipsCount.profile +
                      generalState.SidebarChipsCount.content +
                      generalState.SidebarChipsCount.audience +
                      generalState.SidebarChipsCount.collab +
                      generalState.SidebarChipsCount.monetization +
                      generalState.SidebarChipsCount.charges +
                      generalState.SidebarChipsCount.referral >
                    chips
                      ? generalState.SidebarChipsCount.profile +
                        generalState.SidebarChipsCount.content +
                        generalState.SidebarChipsCount.audience +
                        generalState.SidebarChipsCount.collab +
                        generalState.SidebarChipsCount.monetization +
                        generalState.SidebarChipsCount.charges +
                        generalState.SidebarChipsCount.referral
                      : chips}
                  </span>
                  <span
                    className="bg-[#381c1c] py-2 px-3 border-none rounded-md text-[#ffffff] flex items-center gap-2 cursor-pointer text-xs"
                    onClick={() => {
                      OpenMostChipsInfo(true);
                      mixpanel.track("Clicked the chips on Navbar in Collab");
                    }}
                  >
                    <PiCoins size={16} color="#FFD700" /> Most Chips Collected -{" "}
                    {topCreatorChips}
                  </span>
                </section>
              </section>
              {/* popup menu ------------ */}
              <section className="flex flex-col items-start gap-4">
                {/* Earning */}
                <span
                  className={`text-sm flex md:hidden font-medium ${
                    location.pathname === "/influencer/wallet" ||
                    location.pathname === "/influencer"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2 justify-between`}
                  onClick={() => {
                    mixpanel.track("Clicked on Earning link in Sidebar");
                    navigate("/influencer/wallet");
                  }}
                >
                  <div className="flex gap-2">
                    <Wallet size={18} />
                    <span>Earning</span>
                  </div>
                  <span className="bg-red-700 text-white rounded-full text-[10px] px-2">
                    New
                  </span>
                </span>

                {/* Posts Performance */}
                <span
                  className={`text-sm flex md:hidden font-medium ${
                    location.pathname === "/influencer/posts-performance" ||
                    location.pathname === "/influencer"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2 justify-between`}
                  onClick={() => {
                    mixpanel.track("Clicked on feed link in Sidebar");
                    navigate("/influencer/posts-performance");
                  }}
                >
                  <div className="flex gap-2">
                    <MdAutoGraph size={18} />
                    <span>Post Performance</span>
                  </div>
                  {/* <span className="bg-red-700 text-white rounded-full text-[10px] px-2">
                    New
                  </span> */}
                </span>

                {/* Analytics */}
                <span
                  className={`text-sm font-medium ${
                    location.pathname === "/influencer/analytics"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex justify-between items-center gap-2`}
                  onClick={() => {
                    mixpanel.track("Clicked on Analytics link in Sidebar");
                    navigate("/influencer/analytics");
                  }}
                >
                  <span className="gap-2 flex">
                    <TbDeviceAnalytics size={18} /> Analytics
                  </span>
                </span>

                {/* Boost Visibility */}
                {authState?.loggedUser?.slug && (
                  <span
                    className={`text-sm font-medium flex  ${
                      location.pathname === "/influencer/boostVisibility"
                        ? "text-[#FFFFFF] bg-[#381c1c]"
                        : "text-[#A6A6A6] bg-transparent"
                    }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
                    onClick={() => {
                      mixpanel.track(
                        "Clicked on Boost Visibility link in Sidebar"
                      );
                      navigate("/influencer/boostVisibility");
                    }}
                  >
                    <IoFlashOutline size={18} /> Boost Visibility
                  </span>
                )}

                {/* tools */}
                <span
                  className={`text-sm font-medium  ${
                    location.pathname === "/influencer/tools" ||
                    location.pathname === "/influencer/tools"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  } w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FFFFFF] rounded-md cursor-pointer flex items-center gap-2`}
                  onClick={() => {
                    mixpanel.track("Clicked on Brand Wishlist link in Sidebar");
                    navigate("/influencer/tools");
                  }}
                >
                  <Wrench size={18} /> Free Tools
                </span>

                {/* brand wishlist */}
                <span
                  className={`text-sm font-medium  flex ${
                    location.pathname === "/influencer/brands_wishlist" ||
                    location.pathname === "/influencer/view_brands_list"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  } w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FFFFFF] rounded-md cursor-pointer flex items-center gap-2`}
                  onClick={() => {
                    mixpanel.track("Clicked on Brand Wishlist link in Sidebar");
                    navigate("/influencer/brands_wishlist");
                  }}
                >
                  <MdLoyalty size={18} /> Brand Wishlist
                </span>

                {/* guid hub */}
                <Accordion className=" w-full " type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger
                      className={`text-sm font-medium text-[#A6A6A6] bg-[transparent]
          } w-full py-[6px] relative px-3 hover:text-[#FFFFFF] rounded-md cursor-pointer flex items-center gap-2`}
                    >
                      <div className="flex gap-[8px] ">
                        <MdAutoStories size={18} /> Guide Hub
                      </div>
                    </AccordionTrigger>
                    <AccordionContent>
                      <section className="flex flex-col items-center gap-4 text-sm w-full px-3 box-border mb-3 ">
                        {/* profile guide */}
                        <span
                          className={`text-[#A6A6A6] cursor-pointer hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm `}
                          onClick={() => {
                            mixpanel.track(
                              "Clicked on Your Profile Guide link in Sidebar"
                            );
                            window.open(
                              "https://bit.ly/anchorscollabguide",
                              "_blank"
                            );
                          }}
                        >
                          Your Profile Guide <IoMdOpen />
                        </span>
                        {/* faq */}
                        <span
                          className={`text-[#A6A6A6] cursor-pointer hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm `}
                          onClick={() => {
                            mixpanel.track("Clicked on FAQ link in Sidebar");
                            window.open("https://bit.ly/collabchips", "_blank");
                          }}
                        >
                          Chips: FAQs Answered <IoMdOpen />
                        </span>
                      </section>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </section>
            </div>
          </PopoverContent>
        </Popover>

        <div className="text-white flex gap-2 md:gap-4">
          <Button
            variant="outline"
            className="bg-transparent hidden md:flex"
            onClick={() => {
              mixpanel.track("Clicked on Add Top Links from Sidebar");
              navigate("/influencer/build_profile?page=toplinks");
            }}
          >
            <SquareArrowUpRight size={16} />
            Add Top Links
          </Button>
          {!authState?.loggedUser?.activePlan && (
            <Button
              variant="outline"
              className="group hidden md:flex px-2 md:py-2 md:px-4 items-center gap-1 md:gap-2 bg-transparent border-[#949090] hover:border-transparent"
              onClick={() => {
                mixpanel.track(
                  "Influencer Dashboard : Preview Profile : clicked"
                );
                navigate(`/influencer/edit/?mode=preview`);
              }}
            >
              <Eye
                size={20}
                className="text-[#949090] group-hover:text-[#000]"
              />
              <span className="leading-none text-xs md:text-sm font-inter text-[#949090] group-hover:text-[#000]">
                Preview Profile
              </span>
            </Button>
          )}
          <Button
            variant="destructive"
            className="relative px-2 md:py-2 md:px-4 items-center flex gap-1 md:gap-2"
            onClick={() => {
              navigate("/influencer/plugin/sync-profile");
            }}
          >
            <div className="absolute -top-1 -right-1">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white/70 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
              </span>
            </div>
            <BiSync size={20} />
            <span className="leading-none text-xs md:text-sm font-inter">
              Sync Profile
            </span>
          </Button>
        </div>

        {/* <button
          className="text-[#A6A6A6] text-sm md:text-[14px] items-center flex gap-1 hover:text-[#FFFFFF] p-2 z-10"
          onClick={() => {
            window.open(
              `https://api.whatsapp.com/send?phone=918799710137&text=Hey,%20I%20would%20like%20to%20connect%20with%20anchors%20Team`
            );
            mixpanel.track("Help clicked on Navbar Collab Dashboard");
          }}
        >
          <FaWhatsapp /> Help
        </button> */}

        {/* Feed - Navbar Button - mobile */}
        {/* <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/feed" ||
            location.pathname === "/influencer"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          } md:hidden  py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on feed link in Sidebar");
            navigate("/influencer/feed");
          }}
        >
          <BiNetworkChart size={18} /> Feed
        </span> */}

        <div className="absolute left-[16px] md:left-[28%] flex items-center justify-center text-xs font-inter gap-5">
          {/* <b>Note</b> - Currently you are using&nbsp;<b>Early Access</b> */}
          <img
            src={
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/anchors_Christmas.svg"
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/DiwaliLogoBlack.png"
              // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Collab+White+Logo.svg"
              "https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png"
            }
            alt=""
            className="w-32 md:hidden  cursor-pointer"
            onClick={() => {
              navigate("/");
            }}
          />

          {/* <span
            className="bg-[#381c1c] py-2 px-3 border-none rounded-lg text-[#FFFFFF] hidden md:flex items-center gap-2 cursor-pointer"
            onClick={() => {
              setOpenChipsInfo(true);
              mixpanel.track("Clicked the chips on Navbar in Collab");
            }}
          >
            <PiCoins size={16} color="#FFD700" /> Your Chips Collected -{" "}
            {generalState.SidebarChipsCount.profile +
              generalState.SidebarChipsCount.content +
              generalState.SidebarChipsCount.audience +
              generalState.SidebarChipsCount.collab +
              generalState.SidebarChipsCount.monetization +
              generalState.SidebarChipsCount.charges +
              generalState.SidebarChipsCount.referral >
            chips
              ? generalState.SidebarChipsCount.profile +
                generalState.SidebarChipsCount.content +
                generalState.SidebarChipsCount.audience +
                generalState.SidebarChipsCount.collab +
                generalState.SidebarChipsCount.monetization +
                generalState.SidebarChipsCount.charges +
                generalState.SidebarChipsCount.referral
              : chips}
          </span> */}

          {/* <span
            className="bg-[#381c1c] py-2 px-3 border-none rounded-md text-[#ffffff] hidden md:flex items-center gap-2 cursor-pointer"
            onClick={() => {
              OpenMostChipsInfo(true);
              mixpanel.track("Clicked the chips on Navbar in Collab");
            }}
          >
            <PiCoins size={16} color="#FFD700" /> Most Chips Collected -{" "}
            {topCreatorChips}
          </span> */}
        </div>
      </div>
    </>
  );
};

export default Navbar;
